import { render, staticRenderFns } from "./NumericalCeterisParibus.vue?vue&type=template&id=46b62688&"
import script from "./NumericalCeterisParibus.vue?vue&type=script&lang=js&"
export * from "./NumericalCeterisParibus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports